import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ColumnDef } from '@tanstack/react-table';

import { RootState, useAppDispatch } from '@/store/store';
import { fetchStartet } from '@/store/slices/startetSlice';
import { IStartet } from '@/pages/startet/types';

import Sorting from '@/components/Table/sorting';
import { NameCell } from '@/components/Table/Cell/NameCell';
import DateCellLastAction from '@/components/Table/Cell/DateCellLastAction';
import DateCellNextAction from '@/components/Table/Cell/DateCellNextAction';
import PauseCell from '@/components/Table/Cell/PauseCell';

const useStartet = () => {
  const dispatch = useAppDispatch();
  const { data, loading } = useSelector((state: RootState) => state.startet);

  useEffect(() => {
    dispatch(fetchStartet());
  }, [dispatch]);

  const columns: ColumnDef<IStartet>[] = useMemo(
    () => [
      {
        accessorFn: (row) => row.debtor?.name,
        accessorKey: 'debtorName',
        header: ({ column }) => <Sorting header="Skyldner" column={column} />,
        enableSorting: true,
        size: 340,
        cell: ({ row }) => <NameCell name={row?.original?.debtor?.name} />,
      },
      {
        accessorKey: 'lastAction',
        header: ({ column }) => (
          <Sorting header="Seneste handling" column={column} />
        ),
        enableSorting: true,
        size: 320,
        cell: ({ row }) => (
          <DateCellLastAction
            pdfUrl={row?.original?.pdfUrl}
            action={row?.original?.lastAction?.action}
            date={row?.original?.lastAction?.date}
          />
        ),
      },
      {
        accessorKey: 'nextAction',
        header: ({ column }) => (
          <Sorting header="Næste handling" column={column} />
        ),
        enableSorting: true,
        size: 320,
        cell: ({ row }) => (
          <DateCellNextAction
            action={row?.original?.nextAction?.action}
            date={row?.original?.nextAction?.date}
          />
        ),
      },
      {
        accessorKey: 'isPaused',
        header: '',
        enableSorting: true,
        size: 200,
        cell: ({ row }) =>
          row?.original?.isPaused ? (
            <PauseCell id={row?.original?.id} />
          ) : null,
      },
    ],
    []
  );

  return {
    data,
    loading,
    columns,
  };
};

export default useStartet;
